module.exports = __webpack_public_path__ + "static/media/Katie_Teletraining.bae9f55f.bin";